import React from 'react';
import CircleButton from 'components/v2/buttons/CircleButton';
import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import SessionStore from 'stores/SessionStore';
const BLACK_LISTED_NON_ADMIN_ACTION_FIELD = ['fsc_pending_job_closure'];
export default function NonActionableNextStep({ item }) {
    const { t } = useTranslation();
    const isAdmin = SessionStore.isAdmin();
    const renderIcon = () => {
        return React.createElement(Clock, { className: "w-5 h-5" });
    };
    if (!isAdmin && BLACK_LISTED_NON_ADMIN_ACTION_FIELD.includes(item.field))
        return null;
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex justify-between text-sm text-gray-700  py-1 items-center" },
            React.createElement("span", null, t(sluggify(item.field))),
            React.createElement(CircleButton, { size: "small", disabled: item.complete, onClick: null }, renderIcon()))));
}
